import React from "react";
import { WEBSITE_DATA } from "../constants/dashboard";
import "./Header.css";

const Header = () => {
  return (
    <div className="header">
      <img id="img" src={WEBSITE_DATA.logo} alt="title" />
    </div>
  );
};

export default Header;
